// extracted by mini-css-extract-plugin
export default {"summaryContainer":"Jobs_summaryContainer__MZkhs","summary":"Jobs_summary__HzAvu","pageLink":"Jobs_pageLink__wHFpY"};